/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreApiService } from '../core-api-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createSimcard } from '../fn/sim/create-simcard';
import { CreateSimcard$Params } from '../fn/sim/create-simcard';
import { deleteSimcardById } from '../fn/sim/delete-simcard-by-id';
import { DeleteSimcardById$Params } from '../fn/sim/delete-simcard-by-id';
import { getAllSimcards } from '../fn/sim/get-all-simcards';
import { GetAllSimcards$Params } from '../fn/sim/get-all-simcards';
import { PageDto } from '../models/page-dto';
import { SimcardCreationResponse } from '../models/simcard-creation-response';
import { updateSimcard } from '../fn/sim/update-simcard';
import { UpdateSimcard$Params } from '../fn/sim/update-simcard';

@Injectable({ providedIn: 'root' })
export class SimAPI extends CoreApiService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllSimcards()` */
  static readonly GetAllSimcardsPath = '/sim';

  /**
   * Get all simcards from the system.
   *
   * Paginated call to retrieve all simcards from the system.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSimcards()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSimcards$Response(params?: GetAllSimcards$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDto>> {
    return getAllSimcards(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all simcards from the system.
   *
   * Paginated call to retrieve all simcards from the system.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSimcards$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSimcards(params?: GetAllSimcards$Params, context?: HttpContext): Observable<PageDto> {
    return this.getAllSimcards$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDto>): PageDto => r.body)
    );
  }

  /** Path part for operation `createSimcard()` */
  static readonly CreateSimcardPath = '/sim';

  /**
   * Create a simcard.
   *
   * Create a single simcard from specified information
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSimcard()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSimcard$Response(params?: CreateSimcard$Params, context?: HttpContext): Observable<StrictHttpResponse<SimcardCreationResponse>> {
    return createSimcard(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a simcard.
   *
   * Create a single simcard from specified information
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSimcard$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSimcard(params?: CreateSimcard$Params, context?: HttpContext): Observable<SimcardCreationResponse> {
    return this.createSimcard$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimcardCreationResponse>): SimcardCreationResponse => r.body)
    );
  }

  /** Path part for operation `updateSimcard()` */
  static readonly UpdateSimcardPath = '/sim/{iccid}';

  /**
   * Update a device.
   *
   * Update a device
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSimcard()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSimcard$Response(params: UpdateSimcard$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSimcard(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a device.
   *
   * Update a device
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSimcard$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSimcard(params: UpdateSimcard$Params, context?: HttpContext): Observable<void> {
    return this.updateSimcard$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSimcardById()` */
  static readonly DeleteSimcardByIdPath = '/sim/{iccid}';

  /**
   * Delete a specific simcard.
   *
   * Delete a simcard given that the user has the necessary permissions and the device exists
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSimcardById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSimcardById$Response(params: DeleteSimcardById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSimcardById(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a specific simcard.
   *
   * Delete a simcard given that the user has the necessary permissions and the device exists
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSimcardById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSimcardById(params: DeleteSimcardById$Params, context?: HttpContext): Observable<void> {
    return this.deleteSimcardById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
